// extracted by mini-css-extract-plugin
export var containerStyle = "template_landing_page_generic-module--containerStyle--Ub9hg";
export var coverImageWrapperStyle = "template_landing_page_generic-module--coverImageWrapperStyle--Ncxd1";
export var twoColumnLayoutStyle = "template_landing_page_generic-module--twoColumnLayoutStyle--PcTJ+";
export var wrapperStyle = "template_landing_page_generic-module--wrapperStyle--64jpJ";